/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { UserLifecycleState } from './userLifecycleState';

export type UserState = UserLifecycleState | null;
